module.exports = __webpack_public_path__ + "img/navbar-logo.9219ac93.svg";